module.exports = __webpack_public_path__ + "static/patient-robert-profile-img-66872ff77368f5b9586eab04f5b18b40.png";